module.exports = __webpack_public_path__ + "media/images/flags/4x3/plw-5948ddc6dcb9a681f53db1b832e4c444.svg";